
export const UPDATE_ROOMS_LIST = 'rooms/UPDATE_ROOMS_LIST';
export const UPDATE_ROOM_SCROLL_POSITION = 'rooms/UPDATE_SCROLL_POSITION';
export const UPDATE_ROOM_UNREAD_MESSAGES = 'rooms/UPDATE_UNREAD_MESSAGES';
export const UPDATE_ROOM_STATUS = 'rooms/UPDATE_ROOM_STATUS';
export const UPDATE_ROOM_TYPINGS = 'rooms/UPDATE_ROOM_TYPINGS';
export const UPDATE_ROOM_TALKERS = 'rooms/UPDATE_ROOM_TALKERS';
export const UPDATE_CANNED_RESPONSE_TITLES = 'rooms/UPDATE_CANNED_RESPONSE_TITLES';

export const SAVE_ROOM_SCROLL = 'rooms/SAVE_ROOM_SCROLL';
export const CREATE_ROOM = 'rooms/CREATE_ROOM';
export const SWITCH_ROOM = 'rooms/SWITCH_ROOM';
export const ROOM_LEFT_EXECUTE = 'rooms/ROOM_LEFT_EXECUTE';
export const CLOSE_ROOM = 'rooms/CLOSE_ROOM';
export const STATE_CHANGED = 'rooms/STATE_CHANGED';
export const TALKERS_CHANGED = 'rooms/TALKERS_CHANGED';
export const TYPINGS_CHANGED = 'rooms/TYPING_STATUS_CHANGED';
export const REQUEST_CANNED_RESPONSE_TEXT = 'rooms/REQUEST_CANNED_RESPONSE_TEXT';
export const RECEIVE_CANNED_RESPONSE_TEXT = 'rooms/RECEIVE_CANNED_RESPONSE_TEXT';
export const RECEIVE_CANNED_RESPONSE = 'rooms/RECEIVE_CANNED_RESPONSE';

export const ACCEPT_CALL = 'rooms/ACCEPT_CALL';
export const CALL_ACCEPTED_EXECUTE = 'rooms/CALL_ACCEPTED_EXECUTE';
export const INSERT_CANNED_RESPONSE = 'rooms/INSERT_CANNED_RESPONSE';


export const updateRoomsList = rooms => ({
  type: UPDATE_ROOMS_LIST,
  payload: rooms,
});

export const updateRoomScrollPosition = (roomId, scrollTop) => ({
  type: UPDATE_ROOM_SCROLL_POSITION,
  payload: scrollTop,
  meta: { roomId },
});

export const updateRoomUnreadMessages = (roomId, unreadMessages) => ({
  type: UPDATE_ROOM_UNREAD_MESSAGES,
  payload: unreadMessages,
  meta: { roomId },
});

export const updateRoomStatus = (roomId, status) => ({
  type: UPDATE_ROOM_STATUS,
  payload: status,
  meta: { roomId },
});

export const updateRoomTypings = (roomId, typings) => ({
  type: UPDATE_ROOM_TYPINGS,
  payload: typings,
  meta: { roomId },
});

export const updateRoomTalkers = (roomId, talkers, safeTalkers) => ({
  type: UPDATE_ROOM_TALKERS,
  payload: { talkers, safeTalkers },
  meta: { roomId },
});

export const updateCannedResponseTitles = (cannedResponseTitles, unparsedTitles) => ({
  type: UPDATE_CANNED_RESPONSE_TITLES,
  payload: { cannedResponseTitles, unparsedTitles },
});

export const saveRoomScroll = (roomId, scrollTop) => ({
  type: SAVE_ROOM_SCROLL,
  payload: scrollTop,
  meta: { roomId },
});

export const acceptCall = (roomId, changeRoom = true) => ({
  type: ACCEPT_CALL,
  payload: { changeRoom },
  meta: { roomId },
});

export const callAcceptedExecute = roomId => ({
  type: CALL_ACCEPTED_EXECUTE,
  payload: roomId,
});

export const createRoom = room => ({
  type: CREATE_ROOM,
  payload: room,
});

export const switchRoom = roomId => ({
  type: SWITCH_ROOM,
  payload: roomId,
});

export const closeRoom = ({ roomId, isNeedInformThatRoomIsClosed = true }) => ({
  type: CLOSE_ROOM,
  meta: { roomId, isNeedInformThatRoomIsClosed },
});

export const roomLeftExecute = roomId => ({
  type: ROOM_LEFT_EXECUTE,
  meta: { roomId },
});

export const stateChanged = (roomId, state) => ({
  type: STATE_CHANGED,
  payload: state,
  meta: { roomId },
});

export const talkersChanged = (roomId, talkers) => ({
  type: TALKERS_CHANGED,
  payload: talkers,
  meta: { roomId },
});

export const typingsChanged = (roomId, typings) => ({
  type: TYPINGS_CHANGED,
  payload: typings,
  meta: { roomId },
});

export const requestCannedResponseText = (roomId, id) => ({
  type: REQUEST_CANNED_RESPONSE_TEXT,
  meta: {
    roomId,
    id,
  },
});

export const receiveCannedResponse = titles => ({
  type: RECEIVE_CANNED_RESPONSE,
  payload: titles,
});

export const insertCannedResponse = text => ({
  type: INSERT_CANNED_RESPONSE,
  payload: text,
});
